import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface Props {
  open: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
}

/**
 * Standard unsaved-changes confirmation prompt.
 * Copy is fixed per spec — do not localize or alter without product sign-off.
 */
export function UnsavedChangesAlert({ open, onKeepEditing, onDiscard }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onKeepEditing()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Unsaved changes</AlertDialogTitle>
          <AlertDialogDescription>
            You have unsaved changes. If you close this window, your work will be lost.
            Are you sure you want to close?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onKeepEditing}>Keep Editing</AlertDialogCancel>
          <AlertDialogAction
            onClick={onDiscard}
            className={cn(buttonVariants({ variant: "destructive" }))}
          >
            Discard Changes
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
